export default "__VITE_ASSET__DjM4r0NZ__"